import type { Auth0ContextInterface, GetTokenSilentlyOptions } from '@auth0/auth0-react';

/**
 * A getAccessTokenSilently that always answers with one fixed token, for the
 * auth providers that stand in for Auth0 (demo, trial link).
 *
 * The Auth0 SDK types this as an overloaded function with three call signatures.
 * We satisfy all overloads by returning either a verbose response object or the
 * plain token string based on the `detailedResponse` option, matching the real
 * Auth0 SDK behavior without any type casts.
 */
export function fixedTokenAccessor(token: string): Auth0ContextInterface['getAccessTokenSilently'] {
  function getAccessTokenSilently(
    options?: GetTokenSilentlyOptions
  ): Promise<{ id_token: string; token_type: string; access_token: string; expires_in: number }>;
  function getAccessTokenSilently(options?: GetTokenSilentlyOptions): Promise<string>;
  function getAccessTokenSilently(options?: GetTokenSilentlyOptions) {
    if (options?.detailedResponse) {
      return Promise.resolve({
        id_token: token,
        token_type: 'Bearer',
        access_token: token,
        expires_in: 86400,
      });
    }

    return Promise.resolve(token);
  }

  return getAccessTokenSilently;
}
